import { ConfigurationTreeNodeModel, ConfigurationState, StoreConstants } from '@/types';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<ConfigurationState> = {
  [StoreConstants.Configuration.Mutations.SetTree](state, tree: ConfigurationTreeNodeModel[]) {
    state.tree = tree;
  },
  [StoreConstants.Configuration.Mutations.SetSelectedNodeToExpandOnMount](state) {
    state.expandSelectedNodeOnMount = true;
  },
  [StoreConstants.Configuration.Mutations.ResetSelectedNodeToExpandOnMount](state) {
    state.expandSelectedNodeOnMount = false;
  },
  [StoreConstants.Configuration.Mutations.SetEntraEnabled](state, enabled: boolean) {
    state.entraEnabled = enabled;
  }
};
